import logo from '@/assets/landing/images/logo.svg';

export default function LandingHeader() {
  return (
    <header className="bg-highlight px-4 py-3">
      <div className="landing-container flex items-center justify-between">
        <div className="flex items-center">
          <img src={logo} alt="Logo" className="w-8 h-8 hover:rotate-180 transition-transform duration-500 ease-in-out" />
        </div>
        <div className="flex items-center space-x-4">
          <span className="text-gray-800 font-medium">
            <a href="https://live.tt/" target="_blank" rel="noreferrer">Sobre a LIVE</a>
          </span>
        </div>
      </div>
    </header>
  );
}
